goog.provide('el8.ptdata.careTeamProviders');

goog.require('el8.model.base');
goog.require('el8.data.physicians');
goog.require('el8.service.urls');
goog.require('el8.service.tz');


// kind of similar to el8.ptdata.ptProviders, but it maps more to
// CareTeamPhysicianParticipationPeriod instead of PatientProviderTeamMember
el8.ptdata.careTeamProviders = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.prototype.populate = function(spec) {
        spec = spec || {};
        if (spec.physician) {
            spec.physician_id = el8.data.physicians.create(spec.physician).getId();
        }
        if (spec.inviting_physician) {
            spec.inviting_physician_id = el8.data.physicians.create(spec.inviting_physician).getId();
        }
        this.parent.populate.call(this, spec);
    };

    _class.addIntProperty('physicianId');
    _class.addIntProperty('userId');
    _class.addBoolean('sharingEnabled');
    _class.addBoolean('active');
    _class.addIntProperty('invitingPhysicianId');
    _class.addBoolean('invitePending'); // for the case where they are not elation user yet
    _class.addDateTime('invitationDate');
    _class.addBoolean('invitedByMe'); // true if i am the one invinting
    _class.addBoolean('invitingMe'); // true if i am being invited

    _class.addProperty('specialtyCategories');
    _class.addStringProperty('note');

    _class.addIntProperty('publicAccessUserId');
    _class.addStringProperty('providerLogo'); // 'emr', 'passport', or ''

    _class.addStringProperty('practicingStatus');
    _class.addProperty('enterprise');

    _class.prototype.getPhysician = function() {
        if (this.getPhysicianId()) {
            return el8.data.physicians.getById(this.getPhysicianId());
        }
        else {
            return null;
        }
    };
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.careTeamProviders.noteSummary(this.asSoyMap()).el8_unescape();
    };
    _class.prototype.getInvitingPhysician = function() {
        if (this.getInvitingPhysicianId()) {
            return el8.data.physicians.getById(this.getInvitingPhysicianId());
        }
        else {
            return null;
        }
    };
    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        var physician = this.getPhysician();
        if (physician) {
            mapped['physician'] = physician.asSoyMap();
        }
        if (this.isInvitePending()) {
            var invitingPhysician = this.getInvitingPhysician();
            if (invitingPhysician) {
                mapped['invitingPhysician'] = invitingPhysician.asSoyMap();
            }
        }
        if (this.getInvitationDate()) {
            mapped['invitationDate'] = el8.service.tz.soyStr(this.getInvitationDate());
        }
        mapped['isCareTeamModel'] = true; // used in appchart.providers.careTeam template to tell if the item is care team or old provider
        return mapped;
    };
    _class.prototype.saveProviderNote = function(val) {
        this.setNote(val);
        var that = this;
        $.el8_ajax({
            type: 'POST',
            data: JSON.stringify({note: val}),
            url: el8.service.urls.get('careTeamProviderNote', [that.getPhysicianId()]),
            success: function(data) {
                that.populate(data);
                el8.ptdata.careTeamProviders.trigger(EVENTS.UPDATED, that);
            }
        });
    };

    /**
     * Define EntitySet
     */
    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('allCareTeamMembers'); },
        sortFn: function(a, b) { return b.lastName() - a.lastName(); },
        deleteFn: function(item, successCallbackFn) {
            el8.appservice.notifier.notify('Removing care team member...');
            $.el8_ajax({
                url: el8.service.urls.get('careTeamMember', [item.getId()]),
                type: 'DELETE',
                success: function(data) {
                    el8.appservice.notifier.notify('Care team member removed from list.');
                    if (successCallbackFn) { successCallbackFn(item); }
                }
            });
        }
    });

    that.allActive = function(spec) {
        var all = that.all();
        return all.filter(function(a) { return a.isActive() === true; });
    };

    that.allInactive = function(spec) {
        var all = that.all();
        return all.filter(function(a) { return a.isActive() === false && a.isInvitePending() === false; });
    };

    that.allInvitations = function(spec) {
        var all = that.all();
        return all.filter(function(a) { return a.isInvitePending() === true; });
    };

    that.sortedByGroup = function(spec) {
        spec = spec || {};
        // get all the providers, by group
        var activeMembers = that.allActive();
        var inactiveMembers = that.allInactive();
        var invitations = that.allInvitations();

        var soyMapFn = function(prov) {
            var soyMap = prov.asSoyMap();
            if (spec.indicatePracticeUsers) {
                soyMap.isPracticeUser = el8.data.practiceUsers.isMember(prov.getPhysician().getAccessUserId());
            }
            if (spec.indicateCurrentUser) {
                soyMap.isCurrentUser = prov.getPhysician().getAccessUserId() === el8.data.currUser.getId();
            }
            return soyMap;
        };
        activeMembers = activeMembers.map(soyMapFn);
        invitations = invitations.map(soyMapFn);
        inactiveMembers = inactiveMembers.map(soyMapFn);

        // then sort by name, but current user always goes first
        var sortByFn = function(prov) {
            if (prov.isCurrentUser) { return '0'; } // always show current user first
            else { return prov.physician.lastName; }
        };
        activeMembers = _.sortBy(activeMembers, sortByFn);
        invitations = _.sortBy(invitations, sortByFn);
        inactiveMembers = _.sortBy(inactiveMembers, sortByFn);

        return {
            activeMembers: activeMembers,
            invitations: invitations,
            inactiveMembers: inactiveMembers
        };
    };

    // take an existing mindreader item, and apply the fields used for PLR/icon status:
    // is_active_plr, is_sharing_plr, is_ivite_pending_plr
    that.applyPlrStatusToMindreaderItem = function(item) {
        if (item.model_class === 'CMSPhysician') {
            // TODO: can we do anything here?
        } else if (item.model_class === 'Physician') {
            var all = that.all();

            // default all plr related flags to faulse
            item['isActivePlr'] = false;
            item['isSharingPlr'] = false;
            item['isInvitePendingPlr'] = false;

            for(var i=0; i < all.length; i++) {
                var entry = all[i];
                if (entry.getUserId() === item['access_user_id'] ||
                    entry.getPhysicianId() === item['id']) {
                    item['isActivePlr'] = entry.isActive();
                    item['isSharingPlr'] = entry.isSharingEnabled();
                    item['isInvitePendingPlr'] = false;
                    break;
                }
            }
        }
        return item;
    };

    that.isUserSharing = function(user_id) {
        var all = that.all();
        for(var i=0; i < all.length; i++) {
            var entry = all[i];
            if (entry.getUserId() === user_id) {
                return entry.isSharingEnabled();
            }
        }
        return false;
    };

    that.isUserActive = function(user_id) {
        var all = that.all();
        for(var i=0; i < all.length; i++) {
            var entry = all[i];
            if (entry.getUserId() === user_id) {
                return entry.isActive();
            }
        }
        return false;
    };

    that.isUserInList = function(user_id) {
        var all = that.all();
        for(var i=0; i < all.length; i++) {
            var entry = all[i];
            if (entry.getUserId() === user_id) {
                return true;
            }
        }
        return false;
    };

    // used through out the code to determine if user can grant access to someone
    // e.g., showing the checkbox
    that.canCurrentUserGrantAccess = function() {
        return el8.data.currUser.isPhysician() && el8.data.currPractice.isPracticingEmr() &&
               that.isUserActive(el8.data.currUser.getId());
    };

    // note the camel casing here is all messed up because we're mixing mindreader
    // items with soyMap data, but we are sharing the same template object
    that.applyPlrStatusToSoyMap = function(map) {
        var all = that.all();

        // default all plr related flags to faulse
        map['isActivePlr'] = false;
        map['isSharingPlr'] = false;
        map['isInvitePendingPlr'] = false;

        for(var i=0; i < all.length; i++) {
            var entry = all[i];
            if (entry.getUserId() === map['accessUserId'] ||
                entry.getPhysicianId() === map['id']) {
                map['isActivePlr'] = entry.isActive();
                map['isSharingPlr'] = entry.isSharingEnabled();
                map['isInvitePendingPlr'] = false;
                break;
            }
        }
        return map;
    };

    var super_softLoad = that.softLoad;
    that.softLoad = function(arg, async, noNotify, successCbFn) {
        if (el8Globals.FEATURES.PLR4Everyone) {
            return super_softLoad.call(that, arg, async, noNotify, successCbFn);
        } else {
            return false;
        }
    };

    var super_load = that.load;
    that.load = function(arg, async, noNotify, successCbFn) {
        if (el8Globals.FEATURES.PLR4Everyone) {
            return super_load.call(that, arg, async, noNotify, successCbFn);
        } else {
            return false;
        }
    };

    var super_getById = that.getById;
    that.getById = function(id, _noFetch) {
        if (el8Globals.FEATURES.PLR4Everyone) {
            return super_getById.call(that, id, _noFetch);
        } else {
            return false;
        }
    };

    return that;

})();
